export const INPUT_BIRTHDATE = 'birthDate';
export const INPUT_NAME = 'name';
export const INPUT_LASTNAME = 'lastName';
export const INPUT_GENDER = 'gender';
export const INPUT_OCCUPATION = 'occupation';
export const INPUT_PICTURES = 'pictures';
